<template>
  <div>
    <CRow>
      <CCol>
        <AdwavDashboard />
      </CCol>
    </CRow>
    <CRow>
      <CCol> </CCol>
    </CRow>
    <CRow>
      <CCol> </CCol>
    </CRow>
  </div>
</template>

<script>
import AdwavDashboard from './HomeDash/Adwav/AdwavDashboard';
// import PollWavDashboard from "./HomeDash/PollWav/PollWavDashboard";

export default {
  name: 'HomeDashboard',
  components: { AdwavDashboard },
  data() {
    return {
      collapse: false,
    };
  },
};
</script>
